import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automaattinen laskutus',
  buttons: {
    add_subscription: 'Lisää tilaus',
    suspend_company: 'Keskeytä ravintola',
    restore_company: 'Palauta ravintola',
    edit_suspend: 'Muokkaa keskeytystietoja',
    confirm: 'Vahvista',
    cancel: 'Peruuta',
  },
  modals: {
    suspend_company: {
      title: 'Haluatko varmasti keskeyttää ravintolan {{company}}?',
      description:
        'Tämä peruuttaa kaikki aktiiviset tilaukset, poistaa käytöstä live-tilaukset ja ilmoittaa ravintolan omistajalle peruutuksesta sähköpostitse. Valitse syy ennen vahvistamista.',
      suspense_reason: {
        label: 'Valitse keskeytyksen syy',
        placeholder: 'Valitse syy',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Suljettu tai omistajanvaihdos',
          [SUSPENSE_REASON.LowRoi]: 'Alhainen ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Hinnoittelu-/maksuherkkyys',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Puuttuvat integraatiot / tuotepuutteet',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Heikko käyttöönotto/aktivointi',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Tyytymättömyys tukeen',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Siirtyi kilpailijalle/markkinapaikkaan/omatoimiseen ratkaisuun',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Pettymys markkinoinnin tuloksiin',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Virheellinen rekisteröinti / tiedot',
        },
        validation: {
          required: 'Valitse syy',
        },
      },
      suspense_competitor: {
        label: 'Mihin kilpailijaan he vaihtoivat?',
        placeholder: 'Valitse kilpailija',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Muu',
        },
        validation: {
          required: 'Valitse kilpailija',
        },
      },
      suspense_reason_notes: {
        label: 'Lisätietoja (valinnainen)',
        placeholder: 'Anna lisätietoja',
      },
    },
    restore_company: {
      title: 'Haluatko varmasti palauttaa ravintolan {{company}}?',
      description: 'Sinun on silti luotava tilaus ja otettava live-tilaukset käyttöön manuaalisesti.',
    },
  },
  toasts: {
    failed_to_load_data: 'Tilaustietojen lataaminen epäonnistui',
    failed_to_suspend_company: 'Ravintolan keskeyttäminen epäonnistui. Ota yhteyttä tekniseen tukeen',
    failed_to_restore_company: 'Ravintolan palauttaminen epäonnistui. Ota yhteyttä tekniseen tukeen',
  },
};
